<template>
  <PageHeaderLayout>
    <div class="main-page-content">
      <h3>排班管理</h3>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
  name: "ScheduleManage",
  components: { PageHeaderLayout },
};
</script>
